import { createSlice } from '@reduxjs/toolkit';
import { getPortalRoles, addRole, getPortalModules } from '../apis/roleAPIs';

interface RoleState {
	rolesAndPermission: object;
	loading: boolean;
	error: any;
	rolesModules: any;
}

const initialState: RoleState = {
	rolesAndPermission: [],
	loading: false,
	error: '',
	rolesModules: {}
};

const roleSlice = createSlice({
	name: 'role',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getPortalRoles.pending, (state: RoleState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getPortalRoles.fulfilled,
			(state: RoleState, action: any) => {
				state.loading = false;
				state.error = '';
				state.rolesAndPermission = action?.payload?.data || [];
			}
		);
		builder.addCase(getPortalRoles.rejected, (state: RoleState) => {
			state.loading = false;
			// state.error = action.payload;
		});
		builder.addCase(addRole.pending, (state: RoleState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(addRole.fulfilled, (state: RoleState) => {
			state.loading = false;
			state.error = '';
		});
		builder.addCase(addRole.rejected, (state: RoleState) => {
			state.loading = false;
		});
		builder.addCase(getPortalModules.pending, (state: RoleState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getPortalModules.fulfilled,
			(state: RoleState, action: any) => {
				state.loading = false;
				state.rolesModules = action?.payload?.data;
				state.error = '';
			}
		);
		builder.addCase(getPortalModules.rejected, (state: RoleState) => {
			state.loading = false;
		});
	}
});

// export const {} = roleSlice.actions;
export default roleSlice.reducer;
